import { useEffect, useState } from 'react'

/**
 * Returns a debounced copy of `value` that only updates once `value` has stayed
 * unchanged for `delayMs`. Each change resets the timer; the pending timer is
 * cleared on the next change and on unmount, so the returned value only ever
 * settles on the latest input.
 *
 * Used to throttle the emirate free-text AutoComplete before it drives the
 * Quiqup Platform cities lookup: without this, every keystroke ("D", "Du",
 * "Dub", ...) would fire a fresh (mostly 404) request against the internal
 * Platform API from a public, unauthenticated page.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState<T>(value)

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs)
    return () => clearTimeout(timer)
  }, [value, delayMs])

  return debounced
}
